import React from "react";
import { makeStyles } from "@mui/styles";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

// const contentImage = 'https://s3-alpha-sig.figma.com/img/204a/3c74/7566e20498ea248abc65997cdc32e8f9?Expires=1709510400&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4&Signature=MaCF9AFprvA~FJConfj2c9MgzCQp-nsn-44NazkQz78C397~FeOaDfwdAbQB2PvaKv9rC-5YLyMBMUnmZcZj7GTnK9X4UgC4QoG0GJXIt2PF0cw6dn9QqbSV4oFd1V3rsSpYL73KwdHx7xp9undqRHu3RTqPjosoAHxN8-T8y6H3ijXvfCgKDrj8MAyeDS5-~nEwoE-MwGPQAkQEWM1~idSIJEC56rQztbaTFSAj8~3PxWtrX8CwuBo2EUJ9h7q-THeyvgeXPyIUu5BxRM6e6J03wwXJ-pXftd~JyV-~GhdVeQEsrIgvAfcNF~SKxSyhri0PiYLyw986NZH1tWzRcg__';
// const cmimage = 'https://ud.hp.gov.in/sites/default/files/2023-04/IMG-20230401-WA0000.jpg'
const coi = "https://uplegisassembly.gov.in/Images/yogi.jpg";
const useStyles = makeStyles((theme) => ({
  contentContainer: {
    display: "flex",
    justifyContent: "space-between",
    width: "80%",
    margin: "0 auto",
    flexDirection: "row",
    backgroundColor: "#ECECEC",
    opacity: 0.9,
    padding: theme.spacing(3),
    marginTop: theme.spacing(10),
  },
  textSection: {
    width: "50%", // hiding it till achar sanhita
    color: "black",
  },
  imageSection: {
    width: "48%",
    textAlign: "center",
  },
  header1: {
    fontWeight: "bolder",
    fontSize: "40px",
    marginLeft: theme.spacing(1),
  },
  header2: {
    fontWeight: "bolder",
    fontSize: "26px",
    marginLeft: theme.spacing(1),
  },
  paragraph: {
    margin: theme.spacing(2),
  },
  lastPara: {
    color: "#5E5E5E",
    fontSize: "18px",
    fontWeight: "bold",
    marginTop: theme.spacing(6),
  },
  Info: {
    color: "#CC8500",
    fontSize: "14px",
    marginTop: "10px",
    textShadow: ".5px .5px #CC8500",
  },
}));

const ContentSection = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.contentContainer}>
      <div className={classes.textSection}>
        <Typography variant="h5" className={classes.header1}>
          Fast & Simplified Trust based Plan Approval System
        </Typography>
        <Typography className={classes.paragraph}>
          Fast & Simplified Trust based Plan Approval System with EDCR or auto scutiny of maps in the State of Uttar Pradesh.
        </Typography>
        <Typography variant="h5" className={classes.header2}>
          EDCR Scrutiny Engine:
        </Typography>
        <Typography className={classes.paragraph}>
          E-DCR is an Automatic Scrutiny of Building Plans and Building Plans Approval Management System. It is a unique software that Scans CAD
          drawings and maps them to development rules for approval by municipal bodies.{" "}
        </Typography>
        <Typography className={classes.lastPara}>
          One Product to get Building Plan Approvals across the State-wide <br></br>
          {/* - TCP Department HP */}
        </Typography>
        {/* <Typography className={classes.Info}>
                    * For more information, please contact us at: <a href='mailto:helpdeskobpas.hp@gmail.com'>helpdeskobpas[dot]hp[at]gmail[dot]com</a> or visit: <a href='https://hptcp.hp.gov.in'>https://hptcp.hp.gov.in</a>
                </Typography> */}
      </div>
      <div className={classes.imageSection}>
        <img src={coi} alt="Content" style={{ height: "90%", width: "90%" }} />
      </div>
    </div>
  );
};

export default ContentSection;
